import * as yup from "yup";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { TextField } from "@mui/material";
import { mdiAccountLock } from "@mdi/js";

import AppBar from "components/AppBar";
import AuthForm from "components/AuthForm";
import PageLayout from "components/PageLayout";
import useNotifier from "hooks/useNotifier";
import AuthApi from "api/auth";

const validationSchema = yup.object().shape({
  newPassword: yup.string().required("Password is required").min(8, "Password must be longer than 8 characters"),
  confirmedPassword: yup
    .string()
    .required("Confirm password is required")
    .oneOf([yup.ref("newPassword")], "Passwords must match"),
});

function ConfirmResetPassword() {
  const navigate = useNavigate();
  const { showNotification } = useNotifier();
  const authApi = useMemo(() => new AuthApi(showNotification), [showNotification]);

  /**
   * Send new password
   *
   * @param data
   */
  async function handleSubmit(data: { newPassword: string }): Promise<void> {
    await authApi.resetPassword(data.newPassword);
    navigate("/", { replace: true });
  }

  return (
    <PageLayout appBar={<AppBar backAction={false} noRadius showLogo title='GroupUp' />}>
      <AuthForm<ConfirmResetPasswordForm>
        avatarIcon={mdiAccountLock}
        onSubmit={handleSubmit}
        submitLabel='Reset password'
        title='Reset password'
        validationSchema={validationSchema}
      >
        <TextField name='newPassword' label='New password' type='password' fullWidth />
        <TextField name='confirmedPassword' label='Confirm password' type='password' fullWidth />
      </AuthForm>
    </PageLayout>
  );
}

export default ConfirmResetPassword;

interface ConfirmResetPasswordForm extends Record<string, unknown> {
  newPassword: string;
  confirmedPassword: string;
}
